import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReportMetadata, ReportSchedule ,Report, ReportsForToday, ReportScheduleForHome} from '../models/report.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class ReportService {
    endpoint = environment.apiEndpoint + '/Report/';
    reportScheduleData: ReportMetadata[];

  constructor(private http: HttpClient) { }

getSummaryData(reportYear: any): Observable<any> {
    //console.log("-------ReportService-----------");

    return this.http.get(this.endpoint + 'GetSummaryData?year=' + reportYear);
    }

  getAllReportsBasedOnYear$(reportYear:any):Observable<any>{
      return this.http.get(this.endpoint+'GetAllReportsBasedOnYear?reportYear='+reportYear);
  }
  updateReportState$(reportId:any,reportStatusId:any):Observable<any>
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = [{ reportId: reportId,reportStatusId: reportId }];
    return this.http.post(environment.apiEndpoint + '/Report/UpdateReportState?reportId='+reportId+'&reportStateId='+reportStatusId, body, { headers, observe: 'response' });
  }
  previewPDF$(reportId:any):Observable<any>
  {
     return this.http.get(this.endpoint+"PreviewPDF?reportId="+reportId,{responseType:'blob'}).pipe(map((resp:Blob)=>{
      return new Blob([resp], { type: 'application/pdf' });
     }));
  }

  getReportsForToday(appUserId: number, numberOfRows: number): Observable<ReportsForToday[]> {
    return this.http.get<ReportsForToday[]>(this.endpoint + 'GetReportsForToday?appUserId=' + appUserId + '&numberOfRows=' + numberOfRows);
    }

  getReportScheduleForHome(appUserId: number, numberOfRows: number): Observable<ReportScheduleForHome[]> {
    return this.http.get<ReportScheduleForHome[]>(this.endpoint + 'GetReportScheduleForHome?appUserId=' + appUserId + '&numberOfRows=' + numberOfRows);
    }
}
